module.exports = "HrDashboard";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/hr.dashboard.html
// module id = 445
// module chunks = 0